'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WidgetFactories = exports.WidgetResponse = exports.WidgetRequest = exports.WidgetWindowBridge = undefined;

var _WidgetWindowBridge = require('./WidgetWindowBridge');

var _WidgetWindowBridge2 = _interopRequireDefault(_WidgetWindowBridge);

var _WidgetRequest = require('./WidgetRequest');

var _WidgetRequest2 = _interopRequireDefault(_WidgetRequest);

var _WidgetResponse = require('./WidgetResponse');

var _WidgetResponse2 = _interopRequireDefault(_WidgetResponse);

var _WidgetFactories = require('./WidgetFactories');

var _WidgetFactories2 = _interopRequireDefault(_WidgetFactories);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * This module exports the interface of the Widget package
 * @module Widget
 */

exports.WidgetWindowBridge = _WidgetWindowBridge2.default;
exports.WidgetRequest = _WidgetRequest2.default;
exports.WidgetResponse = _WidgetResponse2.default;
exports.WidgetFactories = _WidgetFactories2.default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@deskpro/apps-sdk-core/lib/main/javascript/Widget/index.js
// module id = 234
// module chunks = 0